(ns nosco.richtext.plugins.drop
  (:require
   ["prosemirror-state" :as prosemirror-state]
   [cljs-bean.core :as bean]
   [clojure.string :as string]
   [nosco.richtext.image-uploads :as image-uploads]
   [nosco.richtext.file-uploads :as file-uploads]
   [nosco.richtext.plugins.placeholder :as plugins-placeholder]
   [nosco.richtext.uploads :as uploads]
   [nosco.richtext.util :as richtext-util]
   [nosco.i18n.translate :as t]
   [nosco.ui.errors :as errors]
   [nosco.util :as util]))

(defonce drop-plugin-key
  (prosemirror-state/PluginKey. "nosco-drop"))

(defn- insert-image! [^js view pos ^js file]
  (if (and (.-size file) (> (.-size file) image-uploads/max-file-size-bytes))
    (errors/show-error-toast!
     {:title (t/t "Image upload failed")
      :text (t/t "File too large. Max file size is 50MB")})
    (let [$pos (.. view -state -doc (resolve pos))
          insert-pos (.after $pos 1)
          data-url-p (util/read-file-as-data-url file)
          upload-url-p (uploads/upload-images [file])

          initial-dimensions-p
          (.then data-url-p richtext-util/get-image-dimensions)

          upload-dimensions-p
          (.then upload-url-p richtext-util/get-image-dimensions)

          placeholder-id-p
          (-> (js/Promise.all [data-url-p initial-dimensions-p])
              (.then
               (fn [[url [width height]]]
                 (let [[width' height'] (uploads/image-initial-dimensions
                                         width
                                         height)]
                   (plugins-placeholder/insert-image-placeholder!
                    view
                    insert-pos
                    url
                    width'
                    height')))))]
      (-> placeholder-id-p
          (.then
           (fn [placeholder-id]
             (-> (js/Promise.all [upload-url-p upload-dimensions-p])
                 ;; Slight delay to reduce visual flickering
                 (util/delay-promise 500)
                 (.then
                  (fn [[url [width height]]]
                    (let [[width' height']
                          (uploads/image-initial-dimensions width height)

                          image-node (.. view -state -schema -nodes -image
                                         (create #js {:src url
                                                      :width width'
                                                      :height height'}))

                          figure-node (.. view -state -schema -nodes -figure
                                          (create #js {:data-align "center"}
                                                  image-node))]
                      (plugins-placeholder/replace-image-placeholder!
                       view
                       placeholder-id
                       figure-node))))
                 (.catch
                  (fn [err]
                    (when placeholder-id
                      (plugins-placeholder/remove-placeholder!
                       view
                       placeholder-id))
                    (throw err))))))
          (.catch
           (fn [err]
             (errors/show-error-toast!
              {:title (t/t "Image upload failed")
               :text (when (string? err) err)})
             (js/console.error err)))))))

(defn- insert-video! [^js view pos file]
  (let [$pos (.. view -state -doc (resolve pos))
        insert-pos (.after $pos 1)
        _ (richtext-util/maybe-insert-empty-paragraph! view insert-pos)
        placeholder-id (plugins-placeholder/insert-video-placeholder!
                        view
                        insert-pos)]
    (-> (uploads/upload-videos [file])
        (.then
         (fn [embed-html]
           (let [node (uploads/create-video-node view embed-html)]
             (plugins-placeholder/replace-video-placeholder!
              view
              placeholder-id
              node))))
        (.catch
         (fn [err]
           (plugins-placeholder/remove-placeholder! view placeholder-id)
           (errors/show-error-toast!
            {:title (t/t "Video upload failed")
             :text (when (string? err) err)}))))))

(defn- insert-file! [^js view pos ^js file]
  (if (and (.-size file) (> (.-size file) file-uploads/max-file-size-bytes))
    (errors/show-error-toast!
     {:title (t/t "File upload failed")
      :text (t/t "File too large. Max file size is 50MB")})
    (let [placeholder-id (plugins-placeholder/insert-file-placeholder!
                          view
                          pos
                          (.-name file))]
      (-> (uploads/upload-files [file])
          ;; Slight delay to avoid flashing spinner
          (util/delay-promise 500)
          (.then
           (fn [res]
             (let [{:keys [url id name]} (bean/bean res)
                   node (.. view -state -schema -nodes -file_link
                            (create #js {:href url :file id :name name}))]
               (plugins-placeholder/replace-file-placeholder!
                view
                placeholder-id
                node))))
          (.catch
           (fn [err]
             (plugins-placeholder/remove-placeholder! view placeholder-id)
             (errors/show-error-toast!
              {:title (t/t "File upload failed")
               :text (when (string? err) err)})
             (js/console.error err)))))))

(defn- handle-drop [^js view ^js event]
  (doseq [file (seq (some-> (.-dataTransfer event) .-files))
          :let [pos (.. view
                        (posAtCoords #js {:left (.-clientX event) :top (.-clientY event)})
                        -pos)]]
    (.preventDefault event)
    (cond
      (string/starts-with? (.-type file) "image/")
      (insert-image! view pos file)

      (string/starts-with? (.-type file) "video/")
      (insert-video! view pos file)

      :else
      (insert-file! view pos file))))

(defn- handle-paste [^js view ^js event]
  (when-not (.. event -clipboardData -types (includes "text/rtf"))
    (when-let [image (first (filter #(string/starts-with? (.-type ^js %) "image/") (.. event -clipboardData -files)))]
      (let [pos (.. view -state -selection -$from (after 1))]
        (insert-image! view pos image))
      true)))

(defn drop-plugin []
  (prosemirror-state/Plugin.
   #js {:key drop-plugin-key
        :props #js {:handleDOMEvents #js {:drop handle-drop}
                    :handlePaste handle-paste}}))
